import * as z from "zod";

export const getAdditionalClaimDocumentsRequest = {
  name: "getAdditionalClaimDocumentsRequest" as const,
  input: z.object({ returnId: z.string() }),
  output: z.discriminatedUnion("state", [
    z.object({ state: z.literal("upload"), description: z.string() }),
    z.object({ state: z.literal("submitted") }),
  ]),
};
